var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.558 9.634c1.924-2.158 5.045-2.158 6.97 0l12.114 13.582c1.925 2.158 1.925 5.656 0 7.814-1.925 2.158-5.045 2.158-6.97 0L16.558 17.448c-1.925-2.158-1.925-5.656 0-7.814Z",
  fill: "#38A58F"
})), /*#__PURE__*/React.createElement("path", {
  d: "m21.268 22.725-4.706-5.276c-.854-.958-1.33-2.18-1.425-3.432l2.895-3.246c1.487-1.667 3.686-2.046 5.498-1.139l.002.003 9.348 10.48c-3.331-2.12-7.62-1.651-10.528 1.409h-.012l-1.072 1.201Z",
  fill: "#4C9E8D",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.43
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.877 20.371c3.362-3.537 8.567-3.612 12.008-.227L23.529 9.62c-1.925-2.16-5.046-2.16-6.972-.002L4.443 23.2c-1.924 2.157-1.924 5.654 0 7.811 1.805 2.023 4.66 2.149 6.596.377l9.826-11.017h.012Z",
  fill: "url(#logo_svg__a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  x1: 23.291,
  y1: 10.653,
  x2: 1.009,
  y2: 28.296,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9AFFD6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.156,
  stopColor: "#7EE5BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#58B2A4"
})))));
export default SvgLogo;